import React from 'react';
import { useTranslation } from 'next-i18next';
import PageMeta from '../components/PageMeta';
import Categories from '../containers/Categories';
import withLayout from '../hoc/withLayout';
import simplePage from '../serverProps/simplePage';

const CategoriesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta
        title={t('categories.head.title')}
        description={t('categories.head.description')}
      />
      <Categories />
    </>
  );
};

export default withLayout(CategoriesPage);

export const getServerSideProps = simplePage;
